

import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { PatientService } from '../../../services/patient.service';
import { UtilService } from '../../../util/utilService';
import * as _ from "lodash"
import { MatDialog } from '@angular/material/dialog';
import moment from 'moment';
import { refreshService } from '../../../services/refersh.service'
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { debounce } from 'lodash';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats, NativeDateAdapter } from '@angular/material/core';
import { LanguageSelectTextboxComponent } from '../../../components/language-select-textbox/language-select-textbox.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ToastrService } from 'ngx-toastr';
import { DoctorService } from '../../../services/doctor.service';
import { StorageService } from '../../../services/storage.service';
interface patientInterface {
  id: number;
  formattedDOB: string;
  vaccinationStartDate: string;
  createdAt: string;

  User: {
    dob: string,
    gender: string
  }
}
export class AppDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    if (displayFormat === 'input') {
      let day: string = date.getDate().toString();
      day = +day < 10 ? '0' + day : day;
      let month: string = (date.getMonth() + 1).toString();
      month = +month < 10 ? '0' + month : month;
      let year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }
    return date.toDateString();
  }
}
export const APP_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
  },
  display: {
    dateInput: 'input',
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: {
      year: 'numeric', month: 'long', day: 'numeric'
    },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
  }
};

@Component({
  selector: 'patient-immunization',
  templateUrl: './immunization.component.html',
  styleUrls: ['./immunization.component.css'],
  providers: [{ provide: DateAdapter, useClass: AppDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }],
})

export class ImmunizationComponent implements OnInit {
  deleteVaccineData:any
  confirmVaccDate: boolean = false
  selectedRowId: any = null
  vaccineBrandsOrg: any = []
  barndQuantity: any = null
  barndName: any = ""
  @Input() patientObj!: patientInterface;
  @Input() doctorObj: any = [];
  @Input() specialVaccineInfo: any = {};
  @Input() specialSituationVaccines: any = [];
  pendingVaccinationDate: any;
  pendingVaccination: any = [];
  vaccineList: any = [];
  upcomingVaccineList: any = [];
  patientDataFromLocal: any;
  patientId: any;
  showInfo: boolean = false;
  @Input() splVaccFlag!: any;
  patientVaccinationDate: any
  minVaccinationDate: any;
  patientDoB!: Date;
  setDOBForMorePData: any;
  setVaccDateForMorePData: any;
  OldDOB: any;
  changedDOB: any;
  @Output() appReady = new EventEmitter<void>();

  @ViewChild("previewVaccineModal") previewVaccineModal: any;
  @ViewChild("specialVaccineModal") specialVaccineModal: any;
  @ViewChild("newSpecialVaccineModal") newSpecialVaccineModal: any;
  @ViewChild("bulkVaccineUpdate") bulkVaccineUpdate: any;
  @ViewChild("confirmVacStartDate") confirmVacStartDate: any;
  @ViewChild("dateFormat_modal") dateFormat_modal: any;
  @ViewChild('langInstructions') langInstructions!: LanguageSelectTextboxComponent;
  @ViewChild("infoPopUp") infoPopUp !: TemplateRef<any>;
  @ViewChild("pendingVaccination_modal") pendingVaccination_modal!: ElementRef;
  notifiedFromLocal: any;
  pendingVaccinationForPrint: any[] = [];


  selectedVaccIndex: any = ""
  saveSpecialVaccButton = false;
  unformattedVaccineList: any[] = [];
  vaccineScheduleListWithVaccinedata: any = [];
  splVaccineName = "";
  displayedColumnsGOVT: string[] = ['visit', 'vaccine', 'receivedDate']
  displayedColumns1: string[] = ['visit', 'vaccine', 'recommendedDate', 'catchupDate'];
  displayedColumns: string[] = ['visit', 'vaccine', 'recommendedDate', 'catchupDate', 'status', 'receivedDate', 'brand', 'notify', 'action'];
  selectedVacRecord: object = {};
  selectedVacVisit: any = {};
  confirmDialogVisible: boolean;
  selectedVacIndex: any = 0;
  selectedBrandIndex: any = null;
  vaccineInventoriBrandId:any =null;
  joiningDate: any = null;
  currentDate = new Date();
  selectedDate = "";
  receivedDate: Date;
  viewOrRecordClicked: string;
  dateError: boolean = false;
  selectedBrand: any = {};
  selectedVaccine: any = {};

  vaccineBrands: any[] = [];
  selectedVaccination: any = []

  ageInYear: any = null
  patientInfoArray: any = [];
  patientMoreData: any = {};

  allAdministeredVaccines: any = [];
  flagForCertificateVacc: boolean = false
  maxDate: any = null;
  minDate: any = null;

  selectedVaccineLabels: any[] = [];
  selectedLanguage: any = "en"
  pendingVaccines: any[] = [];

  allTranscripts: any = [];
  transcriptIndex: number = 0;
  govtVaccineList: any = []
  constructor(private docService: DoctorService, private router: Router, private messageService: MessageService, private patientService: PatientService, private util: UtilService, public dialog: MatDialog, private refreshservice: refreshService, private cdRef: ChangeDetectorRef, private route: ActivatedRoute, private toastr: ToastrService) {
    this.receivedDate = new Date();
  }

  ngOnInit(): void {
    const brandId = this.refreshservice.getBrandId();
    this.vaccineInventoriBrandId = brandId
    console.log(brandId);
    const storedPatientData = localStorage.getItem("patientData");
    if (storedPatientData) {
      this.patientDataFromLocal = JSON.parse(storedPatientData);
    } else {
      this.patientDataFromLocal = null; // Handle the case where no data is found
    }
    this.route.queryParams
      .subscribe((params: any) => {
        console.log("paramsparams", params.patientId);
        this.patientId = params.patientId

      })

    let today = new Date()
    this.maxDate = this.util.reverseDate(today);


    this.getPatientInfoForVac();
    this.getPatientsVaccination(); // includes merge already
    setTimeout(() => {
      this.loadPendingVaccination();
    }, 1000);

    this.groupbyscheduleforasha()
    console.log("patientMoreData", this.patientMoreData);

    if (this.splVaccFlag) {
      this.confirmVaccDate = true
      this.selectedVacIndex = 0;
      setTimeout(() => {
        this.openDialog(this.newSpecialVaccineModal, 'newSpecialVaccineModal')
      }, 500)

    }
    // setTimeout(() => {
    //   var elmnt = document.getElementById(this.selectedRowId);
    //   elmnt.scrollIntoView({behavior: 'smooth', block: 'center', inline : 'center'});

    // }, 1000);


  }
  isValidDate(date: any): boolean {
    return date && !isNaN(new Date(date).getTime());
  }

  onModelChange(event: any) {
    if (event) {
      this.receivedDate = moment(event, 'DD/MM/YYYY').toDate(); // Convert to Date object
      console.log("Updated Date:", this.receivedDate);
      this.cdRef.detectChanges(); // Force UI update
    }
  }
  formattedReceivedDate: string = '';
  onDateChange(event: any) {
    if (event) {
      this.receivedDate = event.value; // Update model with Date object
      this.formattedReceivedDate = moment(event.value).format('DD/MM/YYYY'); // Format date

      console.log("Updated Date:", this.receivedDate, "Formatted Date:", this.formattedReceivedDate);

      // Trigger UI update manually
      this.cdRef.detectChanges();
    }
  }





  groupbyscheduleforasha() {
    this.govtVaccineList = []

    this.patientService.groupbyscheduleforasha(this.patientObj.id ? this.patientObj.id : this.patientMoreData._id).subscribe((response: any) => {
      if (response) {
        // this.allVaccines = response;
        console.log("JUNgov30", response)
        this.govtVaccineList = response;
        for (let i = 0; i < this.govtVaccineList.length; i++) {
          if (this.isJson(this.govtVaccineList[i].name)) {
            let scheduleNames = JSON.parse(this.govtVaccineList[i].name);
            if (scheduleNames && scheduleNames.length > 0) {
              scheduleNames.forEach((langpart: any) => {
                if (langpart.lang == 'en') {
                  this.govtVaccineList[i].name = langpart.text;
                }
              });
            }
          }
        }

        let vaccineArray: any[] = [];
        let newArray: any[] = [];

        let tempArr: any[] = [];

        console.log('ExperimentalJun30', this.govtVaccineList)

        this.govtVaccineList.map((ins: any) => {

          ins.data.map((item: any, idx: any) => {

            if (!tempArr.includes(ins.name)) {
              tempArr.push(ins.name)
              item['vaccineVisit'] = ins.name;
            } else {
              item['vaccineVisit'] = "";
            }
            if (idx % 2 == 0) {
              item["indexValue"] = "even"
            }
            else {
              item["indexValue"] = "odd"
            }

            item['visitName'] = ins.vaccinationName
              ;
            item['index'] = idx;
            item['brandvaccine'] = item.brandvaccine ? item.brandvaccine : ""

            item['catchupDate'] = item.catchUpPeriod && item.catchUpPeriod != "" ? moment(item.dueDate).add(item.catchUpPeriod, 'w') : 'NA';
            item['catchupDate'] = item.catchupDate == 'NA' ? 'NA' : item.catchupDate.format('DD-MM-YYYY');

            if (moment(item.dueDate).isBefore(moment())) {
              item['isPending'] = true
            }
            vaccineArray.push(item);
          });
        });

        var govtVaccineList: any = []
        //  this.unformattedVaccineList = this.govtVaccineList;
        this.govtVaccineList = newArray.map((ins, index) => { return { name: ins.name, selected: false, id: index } });
        // this.alltestVac = newArray.map((ins, index) => { return { name: ins.name, selected: false, id: index } });
        govtVaccineList = vaccineArray;
        console.log("Govt", this.govtVaccineList)

        for (let i = 0; i < govtVaccineList.length; i++) {
          if (this.isJson(govtVaccineList[i].name)) {
            let scheduleNames = JSON.parse(govtVaccineList[i].name);
            if (scheduleNames && scheduleNames.length > 0) {
              scheduleNames.forEach((langpart: any) => {
                if (langpart.lang == 'en') {
                  govtVaccineList[i].vaccinationName = langpart.text;
                }
              });
            }
          }
        }
        govtVaccineList.map((ins: any) => {
          if (ins.administeredDate != null) {
            this.govtVaccineList.push(ins)
          }
        })

        this.govtVaccineList = govtVaccineList
        console.log("govVacccc", this.govtVaccineList)
      }

    })
  }
  getDob() {
    this.dateError = false
    var patientDoB = moment((this.patientMoreData.DOB)).format('DD/MM/YYYY')
    this.patientDoB = new Date(this.patientMoreData.DOB)
    console.log("DOB Date Before Change ", this.patientDoB)
    this.OldDOB = moment((this.patientDoB)).format('DD/MM/YYYY')
    console.log("OldDOB", this.OldDOB);
    // let vacDate = moment(this.patientMoreData.vaccinationStartDate).format('DD/MM/YYYY')
    this.patientVaccinationDate = new Date(this.patientMoreData.vaccinationStartDate)

  }
  getPatientInfoForVac() {
    var patientMoreData: any = JSON.parse(localStorage.getItem("patientMoreData") ?? 'null');
    console.log("may1555555", patientMoreData)
    var patientDoB = moment((patientMoreData.DOB)).format('DD/MM/YYYY')
    this.patientDoB = new Date(patientDoB)
    console.log("DOB", this.patientDoB)
    let vacDate = moment(patientMoreData.vaccinationStartDate).format('DD/MM/YYYY')
    this.patientVaccinationDate = new Date(vacDate)

    this.ageInYear = patientMoreData.age.years
    this.ageInYear = this.ageInYear + " " + "Year"
    console.log("AgeInYear", this.ageInYear)

    let formattedVacStartDate = moment(patientMoreData.vaccinationStartDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
    patientMoreData['formattedVacStartDate'] = formattedVacStartDate;

    this.selectedLanguage = patientMoreData.parent.selectedLanguage ? patientMoreData.parent.selectedLanguage : "en";

    let additionalInfo: any = patientMoreData.additionalInfo ? JSON.parse(patientMoreData.additionalInfo) : null;

    setTimeout(() => {
      if (additionalInfo?.specialVaccination) {

        additionalInfo.specialVaccination.map((ins: any, ind: any) => {
          ins['visitName'] = "Special Vaccines";
          if (ind == 0) {
            ins['vaccineVisit'] = "Special Vaccines";
            ins['index'] = ind
          } else {
            ins['index'] = ind
          }

          if (this.specialVaccineInfo[ins.name]) {
            ins['description'] = this.specialVaccineInfo[ins.name]
          }
        });

        let specialVaccines = { name: "Special Vaccines", data: additionalInfo.specialVaccination }
        this.unformattedVaccineList.push(specialVaccines);
        this.vaccineScheduleListWithVaccinedata = [...additionalInfo.specialVaccination, ...this.vaccineScheduleListWithVaccinedata];

        console.log("Vaccines", this.vaccineScheduleListWithVaccinedata)
      } else {
        let additionalInfo: any = {};
        additionalInfo['specialVaccination'] = [
          {
            administeredDate: "",
            administeredStatus: null,
            name: "",
            vaccineVisit: "Special Vaccines",
            visitName: "Special Vaccines"
          }
        ];
        // this.vaccineList = [...additionalInfo.specialVaccination, ...this.vaccineList]
      }
    }, 500);

    let patInformationArray = [];

    let birth = {
      key: 'Birth Date',
      value: moment(patientMoreData.formattedDOB, 'DD/MM/YYYY').format('DD/MM/YY')
    };

    this.minDate = this.util.reverseDate(moment(patientMoreData.formattedDOB, 'DD/MM/YYYY').format('MM/DD/YY'));
    console.log('MINDATE', this.minDate)

    let vacStartDate = {
      key: 'Vac Start Date',
      value: moment(patientMoreData.vaccinationStartDate).format('DD/MM/YY')
    }

    let joiningDate = {
      key: 'Joining Date',
      value: moment(patientMoreData.createdAt).format('DD/MM/YY')
    }

    var y = moment(patientMoreData.formattedDOB, 'DD/MM/YYYY')
    var x = moment(patientMoreData.createdAt)

    let ageObj = moment.duration(x.diff(y))
    let ageAtJoining = {
      key: 'Age at Joining',
      value: `${Math.floor(ageObj.years())}y ${Math.floor(ageObj.months())}m ${Math.floor(ageObj.days())}d`
    }

    patInformationArray.push(birth, vacStartDate, joiningDate, ageAtJoining);
    this.joiningDate = joiningDate
    this.patientInfoArray = patInformationArray;
    console.log("patInformationArray", patInformationArray);
    console.log("AUGGG30", this.patientInfoArray)
    this.patientMoreData = patientMoreData;
  }
// 🩺 Current + Upcoming vaccines = due today or after, including administered ones and special vaccines
// 🩺 Show vaccines from last 6 months + future (Current & Upcoming)
private formatKeyForDedupe(v: any) {
  const name = (v?.name || '').toString().trim().toLowerCase();
  const date = (v?.administeredDate || v?.dueDate || '').toString().trim();
  const visit = (v?.visitName || '').toString().trim().toLowerCase();
  return `${name}||${date}||${visit}`;
}

private safeSetBrandId(id: any) {
  // fix for "Cannot read properties of undefined (reading 'toString')"
  try {
    if (id !== undefined && id !== null) {
      this.refreshservice.setBrandId(id.toString ? id.toString() : String(id));
    } else {
      // don't call setBrandId if id missing
      console.warn('safeSetBrandId: inventory.id is missing - skipping setBrandId');
    }
  } catch (err) {
    console.error('safeSetBrandId error', err);
  }
}

// ---------------------------
// getCurrentAndUpcomingVaccines + getPastVaccines
// (6 months window: last 6 months up to future)
// ---------------------------
getCurrentAndUpcomingVaccines(vaccineList: any[]): any[] {
  if (!Array.isArray(vaccineList)) return [];

  const today = moment();
  const cutoff = today.clone().subtract(6, 'months');
  const seen = new Set<string>();
  const out: any[] = [];

  for (const v of vaccineList) {
    const key = this.formatKeyForDedupe(v);
    if (seen.has(key)) continue;
    seen.add(key);

    // 🩺 Special Vaccines → check administeredDate only
    if (v.visitName === 'Special Vaccines') {
      const admDate = v.administeredDate
        ? moment(v.administeredDate, ['DD-MMM-YYYY', 'DD MMM, YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD'], true)
        : null;

      if (!admDate || !admDate.isValid()) {
        out.push(v); // show unscheduled specials
      } else if (admDate.isSameOrAfter(cutoff)) {
        out.push(v); // within 6 months or future
      }
      continue;
    }

    // 🧩 Normal vaccines → decide by dueDate/unformattedDueDate
    const due = v.unformattedDueDate
      ? moment(v.unformattedDueDate)
      : v.dueDate
      ? moment(v.dueDate, ['DD MMM, YYYY', 'DD-MM-YYYY'], true)
      : null;

    if (due && due.isValid() && due.isSameOrAfter(cutoff)) {
      out.push(v);
    }
  }

  return this.ensureSpecialHeaderAfterFilter(out);
}

getPastVaccines(vaccineList: any[]): any[] {
  if (!Array.isArray(vaccineList)) return [];

  const today = moment();
  const cutoff = today.clone().subtract(6, 'months');
  const seen = new Set<string>();
  const out: any[] = [];

  for (const v of vaccineList) {
    const key = this.formatKeyForDedupe(v);
    if (seen.has(key)) continue;
    seen.add(key);

    // 🩺 Special Vaccines → classify by administeredDate
    const admDate = v.administeredDate
      ? moment(v.administeredDate, ['DD-MMM-YYYY', 'DD MMM, YYYY', 'DD-MM-YYYY', 'YYYY-MM-DD'], true)
      : null;
    if (v.visitName === 'Special Vaccines') {
      if (admDate && admDate.isValid() && admDate.isBefore(cutoff)) {
        out.push(v);
      }
      continue;
    }

    // 🧩 Normal vaccines → use dueDate/unformattedDueDate
    const due = v.unformattedDueDate
      ? moment(v.unformattedDueDate)
      : v.dueDate
      ? moment(v.dueDate, ['DD MMM, YYYY', 'DD-MM-YYYY'], true)
      : null;

    if (due && due.isValid() && due.isBefore(cutoff)) {
      out.push(v);
    }
  }

  return this.ensureSpecialHeaderAfterFilter(out);
}

// ---------------------------
// mergeSpecialVaccinesIntoList
// Merge from localStorage patientMoreData.additionalInfo.specialVaccination
// into vaccineScheduleListWithVaccinedata without duplicates, keep header only once.
// ---------------------------
mergeSpecialVaccinesIntoList() {
  try {
    const patientMoreData: any = JSON.parse(localStorage.getItem('patientMoreData') ?? 'null');
    if (!patientMoreData) return;

    const additionalInfo: any = patientMoreData.additionalInfo ? JSON.parse(patientMoreData.additionalInfo) : null;
    const localSpecials: any[] = additionalInfo?.specialVaccination ?? [];
    if (!Array.isArray(localSpecials) || localSpecials.length === 0) return;
    if (!Array.isArray(this.vaccineScheduleListWithVaccinedata)) this.vaccineScheduleListWithVaccinedata = [];

    // Build existing key set from current list
    const existingKeys = new Set<string>(
      this.vaccineScheduleListWithVaccinedata.map((v:any) => this.formatKeyForDedupe(v))
    );

    // Append only non-duplicate specials
    for (let i = 0; i < localSpecials.length; i++) {
      const s = { ...localSpecials[i] }; // clone to avoid mutating stored object
      s.visitName = 'Special Vaccines';
      // We'll set vaccineVisit header later
      const key = this.formatKeyForDedupe(s);
      if (!existingKeys.has(key)) {
        // ensure index set for stable ordering among specials (local first in the order stored)
        s.index = s.index ?? i;
        s.administeredStatus = !!s.administeredStatus;
        this.vaccineScheduleListWithVaccinedata.push(s);
        existingKeys.add(key);
      }
    }

    // ensure specials stay at top and only first special shows vaccineVisit header
    this.ensureSpecialsAtTop();
  } catch (err) {
    console.error('mergeSpecialVaccinesIntoList error', err);
  }
}

// ---------------------------
// ensureSpecialsAtTop
// Moves all "Special Vaccines" items to top and sets first vaccineVisit header only.
// Idempotent.
// ---------------------------
ensureSpecialsAtTop() {
  if (!Array.isArray(this.vaccineScheduleListWithVaccinedata)) return;

  const specials = this.vaccineScheduleListWithVaccinedata.filter((v: any) => v.visitName === 'Special Vaccines');
  const normal = this.vaccineScheduleListWithVaccinedata.filter((v: any) => v.visitName !== 'Special Vaccines');

  // set the heading on first special only
  specials.sort((a: any, b: any) => {
    // put administeredDate ascending (old->new) OR keep index order if present
    const da = a.administeredDate ? moment(a.administeredDate, ['DD-MMM-YYYY', 'DD MMM, YYYY', 'YYYY-MM-DD'], true) : null;
    const db = b.administeredDate ? moment(b.administeredDate, ['DD-MMM-YYYY', 'DD MMM, YYYY', 'YYYY-MM-DD'], true) : null;
    if (da && db && da.isValid() && db.isValid()) return da.diff(db);
    return (a.index ?? 0) - (b.index ?? 0);
  });

  specials.forEach((s: any, i: number) => {
    s.vaccineVisit = i === 0 ? 'Special Vaccines' : '';
  });

  this.vaccineScheduleListWithVaccinedata = [...specials, ...normal];
}
getPatientsVaccination = () => {
  // reset
  this.vaccineScheduleListWithVaccinedata = [];

  const patientMoreData: any = JSON.parse(localStorage.getItem('patientMoreData') ?? 'null');
  if (!patientMoreData) {
    console.warn('getPatientsVaccination: patientMoreData missing');
    return;
  }

  const patientId = this.patientId || this.patientObj?.id || patientMoreData?._id;
  const joiningDate = moment(patientMoreData.createdAt).format('DD MMM, YYYY');
  const today = moment();
  const tempVisitHeaderTracker: string[] = [];

  this.patientService.getPatientsVaccination(patientId).subscribe((response: any) => {
    if (!response) return;
    const rawSchedule = response;
    const allVaccines: any[] = [];
    const administeredVaccines: any[] = [];
    const pendingVaccines: any[] = [];

    // normalize multilingual names and flatten
    rawSchedule.forEach((schedule: any, scheduleIndex: number) => {
      if (this.isJson(schedule.name)) {
        try {
          const nameObj = JSON.parse(schedule.name);
          const en = nameObj.find((n: any) => n.lang === 'en');
          if (en) schedule.name = en.text;
        } catch (e) { /* ignore */ }
      }

      (schedule.data || []).forEach((item: any, idx: number) => {
        // assign visit header only for the first item of each schedule
        if (!tempVisitHeaderTracker.includes(schedule.name)) {
          tempVisitHeaderTracker.push(schedule.name);
          item.vaccineVisit = schedule.name;
        } else {
          item.vaccineVisit = '';
        }

        item.indexValue = (scheduleIndex % 2 === 0) ? 'even' : 'odd';
        item.visitName = schedule.name;
        item.index = idx;

        // catchup logic
        if (item.catchUpPeriod && item.dueDate) {
          try {
            item.catchupDate = moment(item.dueDate).add(item.catchUpPeriod, 'w').format('DD-MM-YYYY');
          } catch (e) {
            item.catchupDate = 'NA';
          }
        } else {
          item.catchupDate = 'NA';
        }

        item.beforeJoining = moment(item.dueDate).isBefore(joiningDate);
        item.isOverdue = item.catchupDate !== 'NA'
          && moment(item.catchupDate, 'DD-MM-YYYY').isBefore(today)
          && !item.administeredStatus;

        if (item.administeredStatus) administeredVaccines.push(item);
        if (item.dueDate && moment(item.dueDate).isBefore(today) && !item.administeredStatus) {
          item.isPending = true;
          pendingVaccines.push(item);
        }

        allVaccines.push(item);
      });
    });

    // save flattened server list
    this.unformattedVaccineList = rawSchedule;
    this.vaccineScheduleListWithVaccinedata = [...allVaccines];

    // merge local special vaccines (from patientMoreData.additionalInfo) — avoids creating duplicates
    this.mergeSpecialVaccinesIntoList();

    // make sure specials at top with single header
    this.ensureSpecialsAtTop();

    // derive auxiliary arrays
    this.vaccineList = allVaccines;
    this.pendingVaccines = pendingVaccines;
    this.allAdministeredVaccines = administeredVaccines;

    // merge local pending notifications & set isNotifiedLocally flag
    this.mergeLocalPendingVaccines(patientId);

    // detect changes so UI updates immediately
    this.cdRef.detectChanges();

    console.log('Final vaccineScheduleListWithVaccinedata:', this.vaccineScheduleListWithVaccinedata);
  }, (err) => {
    console.error('getPatientsVaccination error', err);
  });
};

// ---------------------------
// markVaccineAsTaken (adjusted to safety & refresh properly)
// ---------------------------
markVaccineAsTaken() {
  if (!this.selectedVaccine) {
    this.messageService.add({ severity: 'warn', detail: 'No vaccine selected.' });
    return;
  }

  const parsedDate = this.receivedDate;
  if (!parsedDate || !moment(parsedDate).isValid()) {
    this.messageService.add({ severity: 'error', detail: 'Invalid date. Please check the received date.' });
    return;
  }

  const formattedDate = moment(parsedDate).format('DD-MMM-YYYY');
  const vaccine = this.selectedVaccine;
  const patientId = this.patientObj?.id ?? this.patientMoreData?._id;

  const postData = {
    id: vaccine.id,
    name: vaccine.name,
    administeredDate: formattedDate,
    administeredStatus: true,
    description: vaccine.description,
    due: vaccine.due,
    dueDate: vaccine.dueDate,
    imageUrl: '',
    notes: '',
    comboVaccineId: this.selectedBrand?.id ?? null
  };

  this.patientService.markVaccineAsTaken(postData, patientId).subscribe((response: any) => {
    if (!response) return;

    // inventory update - guard setBrandId
    const inventory = response.reducedInventory;
    if (inventory) {
      this.barndQuantity = inventory.quantity;
      this.barndName = inventory.brandName;
      this.vaccineInventoriBrandId = inventory.id;
      this.safeSetBrandId(inventory.id);
    }

    this.messageService.add({
      severity: 'custom',
      detail: `${this.barndName || ''}: ${this.barndQuantity ?? ''} Remaining`
    });

    // remove from pending localStorage if present
    let localPending = JSON.parse(localStorage.getItem('pendingVaccinationForPrint') ?? '[]');
    const entryIndex = localPending.findIndex((p: any) => p.patientId == patientId);
    if (entryIndex !== -1) {
      const vaccineIdToRemove = String(vaccine.patVacId ?? vaccine.id);
      localPending[entryIndex].data = localPending[entryIndex].data.filter(
        (v: any) => String(v.patVacId ?? v.id) !== vaccineIdToRemove
      );
      if (!localPending[entryIndex].data.length) localPending.splice(entryIndex, 1);
      localStorage.setItem('pendingVaccinationForPrint', JSON.stringify(localPending));
    }

    // update local patientMoreData (we keep the server as source of truth)
    this.patientMoreData.vaccinationStartDate = this.setVaccDateForMorePData ?? this.patientMoreData.vaccinationStartDate;
    this.changedDOB = moment(this.patientMoreData.DOB).format('DD/MM/YYYY');
    this.patientMoreData.formattedDOB = this.changedDOB;

    // Refresh lists: re-fetch server schedule then merge local specials and re-render
    setTimeout(() => {
      this.getPatientsVaccination();
      this.getPatientInfoForVac();

      // local merge is idempotent and ensures special header shows even if local-only
      this.mergeSpecialVaccinesIntoList();
      this.ensureSpecialsAtTop();

      this.cdRef.detectChanges();
    }, 100);

    this.closeDialog();
  }, (err) => {
    console.error('markVaccineAsTaken error', err);
    this.messageService.add({ severity: 'error', detail: 'Failed to mark vaccine as taken.' });
  });
}



  getUpcomingVaccines(vaccineList: any[]): any[] {
    return vaccineList.filter(v => {
      // Prefer unformattedDueDate if available, else skip
      const due = v.unformattedDueDate ? new Date(v.unformattedDueDate) : null;
      // Show only if vaccine is upcoming or due today, and not already administered
      return due && due >= this.currentDate && !v.administeredStatus;
    });
  }

  // getPastVaccines(vaccineList: any[]): any[] {
  //   return vaccineList.filter(v => {
  //     const due = v.unformattedDueDate ? new Date(v.unformattedDueDate) : null;
  //     return due && due < this.currentDate;
  //   });
  // }
  /** Merge specialVaccination entries from patientMoreData (localStorage) into
 *  vaccineScheduleListWithVaccinedata and keep them at the top.
 *  Removes duplicates by (name + administeredDate).
 */





  mergeLocalPendingVaccines(patientId: string) {
    const localPending = JSON.parse(localStorage.getItem("pendingVaccinationForPrint") ?? "[]");
    const currentEntry = localPending.find((p: any) => p.patientId === patientId);

    if (!this.vaccineScheduleListWithVaccinedata) return;

    const notifiedIds = (currentEntry?.data || []).map((v: any) => String(v.patVacId ?? v.id));

    this.vaccineScheduleListWithVaccinedata.forEach((vaccine: any) => {
      vaccine.isNotifiedLocally = notifiedIds.includes(String(vaccine.patVacId ?? vaccine.id)) && !vaccine.administeredStatus;
    });

    const finalNotified = this.vaccineScheduleListWithVaccinedata.filter(
      (v: any) => (v.notifiedOn || v.isNotifiedLocally) && !v.administeredStatus
    );

    // Clean and update localStorage
    const newLocalPending = [...localPending];
    const existingIndex = newLocalPending.findIndex(p => p.patientId === patientId);

    if (existingIndex !== -1) {
      const cleanedData = newLocalPending[existingIndex].data.filter(
        (v: any) => !this.vaccineScheduleListWithVaccinedata.some(
          (live: any) => String(live.patVacId ?? live.id) === String(v.patVacId ?? v.id) && live.administeredStatus
        )
      );

      const existingIds = cleanedData.map((v: any) => String(v.patVacId ?? v.id));
      const merged = [...cleanedData, ...finalNotified.filter(
        (v: any) => !existingIds.includes(String(v.patVacId ?? v.id))
      )];

      newLocalPending[existingIndex].data = merged;
      newLocalPending[existingIndex].suggestedDate = this.pendingVaccinationDate;
    } else if (finalNotified.length > 0) {
      newLocalPending.push({
        patientId,
        suggestedDate: this.pendingVaccinationDate,
        data: finalNotified
      });
    }

    localStorage.setItem("pendingVaccinationForPrint", JSON.stringify(newLocalPending));
  }

  loadPendingVaccination() {
    const pendingVaccines = JSON.parse(localStorage.getItem("pendingVaccinationForPrint") || "[]");
    const patientData = pendingVaccines.find((p: any) => p.patientId == this.patientId);

    if (patientData) {
      this.pendingVaccinationDate = patientData.suggestedDate;
      this.selectedVaccination = [...patientData.data];
      console.log("✅ Loaded Vaccinations for Patient:", this.selectedVaccination);
    } else {
      this.selectedVaccination = [];
      console.warn("⚠️ No pending vaccinations found for this patient.");
    }

    if (Array.isArray(this.vaccineScheduleListWithVaccinedata)) {
      this.vaccineScheduleListWithVaccinedata.forEach((vaccine: any) => {
        const isMatch = this.selectedVaccination.some((selected: any) =>
          String(selected.patVacId ?? selected.id) === String(vaccine.patVacId ?? vaccine.id)
        );
        if (isMatch) {
          vaccine.isNotifiedLocally = true;
        }
      });
    } else {
      console.warn("⚠️ vaccineScheduleListWithVaccinedata is not initialized.");
    }

    console.log("🧪 Updated vaccineScheduleListWithVaccinedata:", this.vaccineScheduleListWithVaccinedata);
  }

  isVaccineSelected(vaccine: any): boolean {
    let pendingVaccines = JSON.parse(localStorage.getItem("pendingVaccinationForPrint") || "[]");
    let patientData = pendingVaccines.find((p: any) => p.patientId === this.patientId);

    return patientData?.data.some((v: any) => v.name === vaccine.name && v.visitName === vaccine.visitName) || false;
  }
  getVaccData(element: any, event: MatCheckboxChange) {
    if (event.checked) {
      // ✅ Add to selected list if not already present
      if (!this.selectedVaccination.some((v: any) => v.name === element.name && v.visitName === element.visitName)) {
        this.selectedVaccination.push(element);
      }
    } else {
      // ❌ Remove if unchecked
      this.selectedVaccination = this.selectedVaccination.filter(
        (v: any) => v.name !== element.name || v.visitName !== element.visitName
      );

      // 🔍 Check if no other vaccines from same visit remain selected
      const remainingSameVisit = this.selectedVaccination.filter((v: any) => v.visitName === element.visitName);

      if (remainingSameVisit.length <= 0) {
        // 🧹 Clear the pendingVaccinationDate for this vaccine
        this.pendingVaccinationDate = null;
      }
    }

    console.log("✅ Updated Selected Vaccination List:", this.selectedVaccination);
  }


  selectedRowIndex = -1;
  selectedRows(item: any) {
    this.selectedRowIndex = item.id;

  }
  savePendingVaccination() {
    console.log("🔍 Selected Vaccination Before Saving:", this.selectedVaccination, this.pendingVaccinationDate);

    const patientId = this.patientId;
    let pendingVaccines = JSON.parse(localStorage.getItem("pendingVaccinationForPrint") || "[]");
    const existingIndex = pendingVaccines.findIndex((p: any) => p.patientId === patientId);

    const hasSelectedVaccines = this.selectedVaccination && this.selectedVaccination.length > 0;
    const hasPendingDate = this.pendingVaccinationDate != null;

    // 🧹 Allow complete removal if existing entry is being cleared
    if (!hasSelectedVaccines && existingIndex === -1) {
      this.messageService.add({ severity: 'custom', detail: 'Please Select Pending Vaccine' });
      return;
    }

    // 🗓️ Require date only if some vaccines are selected
    if (!hasPendingDate && hasSelectedVaccines) {
      this.messageService.add({ severity: 'custom', detail: 'Please Select Date' });
      return;
    }

    this.closeDialog();

    if (!hasSelectedVaccines) {
      // ❌ User removed all selections — delete the entry
      console.log("🗑️ Removing all pending vaccines for patient");
      pendingVaccines.splice(existingIndex, 1);
    } else {
      // ✅ Add or update entry
      const updatedEntry = {
        patientId,
        suggestedDate: this.pendingVaccinationDate,
        data: [...this.selectedVaccination]
      };

      if (existingIndex !== -1) {
        pendingVaccines[existingIndex] = updatedEntry;
      } else {
        pendingVaccines.push(updatedEntry);
      }
    }

    localStorage.setItem("pendingVaccinationForPrint", JSON.stringify(pendingVaccines));
    console.log("✅ Saved Pending Vaccines:", pendingVaccines);

    this.getPatientsVaccination();
  }








  onDateChangeForVacc(event: any) {
    this.pendingVaccinationDate = event.value
  }
  joinMoment: any = null;
  cutoffMoment: any = null;
  selectFollowUpMessage(event: any) {

    // aaleenm
    // var followupmessage = this.langInstructions.getValue()
    // if (followupmessage == event.value) {

    // }
    // else {
    //   this.langInstructions.appendTexttoBox(event.value)

    // }

    console.log("vaccineList12345", this.vaccineList);

    if (true) {
      this.vaccineList.map((ins: any) => {
        if (ins.isOverdue) {
          this.pendingVaccination.push(ins)
        }
        else if (!ins.administeredStatus) {
          this.upcomingVaccineList.push(ins)
        }
      })
// 🧩 Deduplicate + filter pendingVaccination (6 months before joining)
// 🧩 Filter pendingVaccination based on current date (last 6 months and future)
if (this.pendingVaccination?.length) {
  const today = moment(); // current date
  const cutoffMoment = today.clone().subtract(6, 'months');

  this.pendingVaccination = this.pendingVaccination
    .reduce((unique: any[], vaccine: any) => {
      if (!unique.some(obj => obj.name === vaccine.name)) {
        unique.push(vaccine);
      }
      return unique;
    }, [])
    .filter((vaccine: any) => {
      // parse vaccine due date
      const due = vaccine.unformattedDueDate
        ? moment(vaccine.unformattedDueDate)
        : vaccine.dueDate
        ? moment(vaccine.dueDate, ['DD MMM, YYYY', 'DD-MM-YYYY'])
        : null;

      // keep vaccines due within last 6 months or in future
      return due && due.isSameOrAfter(cutoffMoment);
    });

  console.log('Current Date:', today.format('DD-MMM-YYYY'));
  console.log('6 Month Cutoff (Before Today):', cutoffMoment.format('DD-MMM-YYYY'));
  console.log('Filtered Pending Vaccines:', this.pendingVaccination);
}


      // 🧩 filter by Age at Joining (6 months before joining)
// 🧩 Filter upcoming vaccines based on Joining Date (keep last 6 months and future)
// 🧩 Filter upcoming vaccines based on current age (DOB → today, minus 6 months)
// 🧩 Show only FUTURE vaccines (due after today)
if (this.patientDoB) {
  const today = moment(); // current date

  this.upcomingVaccineList = this.upcomingVaccineList.filter((vaccine: any) => {
    // parse vaccine due date
    const due = vaccine.unformattedDueDate
      ? moment(vaccine.unformattedDueDate)
      : vaccine.dueDate
      ? moment(vaccine.dueDate, ['DD MMM, YYYY', 'DD-MM-YYYY'])
      : null;

    // ✅ include only if due date exists AND is after today
    return due && due.isAfter(today, 'day');
  });

  console.log('DOB:', moment(this.patientDoB).format('DD-MMM-YYYY'));
  console.log('Today:', today.format('DD-MMM-YYYY'));
  console.log('Filtered Upcoming (Future Only):', this.upcomingVaccineList);
}





      console.log("upcomingVaccineList 123", this.upcomingVaccineList, this.joiningDate);

      if (event == 0) {
        // this.openDialog(this.pendingVaccination_modal, 'pendingVaccination_modal');
      }

    }


  }







  isJson(str: any) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }




  openNewSpecialVaccine = () => {
    this.receivedDate = null;
    this.confirmVaccDate = true
    this.selectedVacIndex = 0;
    this.openDialog(this.newSpecialVaccineModal, 'newSpecialVaccineModal')
  }

  openBulkVaccineUpdate = () => {
    let allTranscripts = localStorage.getItem("allTranscripts");
    if (allTranscripts) {
      allTranscripts = JSON.parse(localStorage.getItem("allTranscripts") ?? 'null');
    }

    this.allTranscripts = allTranscripts;

    console.log('ALL TRANSCRIPTS', allTranscripts)

    this.openDialog(this.bulkVaccineUpdate, 'bulkVaccineUpdate');
  }

  changeTranscriptIndex(type: any) {
    let ind = this.transcriptIndex;

    if (type == 1) {

      if (ind >= this.allTranscripts.length - 1) {
        this.transcriptIndex = ind - 1
      }

    } else {

      if (ind < this.allTranscripts.length - 1) {
        this.transcriptIndex = ind + 1
      }

    }
  }

  closeDialog() {
    this.selectedDate = "";
    setTimeout(() => {
      this.receivedDate = null;
    }, 1000);
    this.selectedBrand = {};
    this.selectedBrandIndex = null;
    this.selectedVaccIndex = null
    // this.selectedVacVisit = {}
    this.dialog.closeAll()
  }

  getBrandsByVaccineId = () => {
    let vaccineIds: any[] = [];
    this.selectedVacVisit.data.map((ins: any) => {
      if (!ins.administeredStatus) {
        vaccineIds.push(ins.id)
      }
    })

    let postData = {
      vaccineIds: vaccineIds
    }

    this.patientService.getBrandsByVaccineId(postData).subscribe((response: any) => {
      if (response) {
        this.vaccineBrandsOrg = response;

        this.selectVaccine(0, this.selectedVaccine);
      }
    });
  }

  navigateToCertificate() {
    localStorage.setItem("isForImmunization", "true")
    this.refreshservice.OnPatTopNav_MenuSelected(this.patientObj.id + "", this.refreshservice.EventName_Certificate);
  }

  uploadBulkVaccination = () => {

    let dueVaccineArray = this.pendingVaccines;
    let selectedVacArray: any[] = []

    dueVaccineArray.forEach(item => {
      let newObj = {}
      if (item.selected) {
        newObj = {
          "patVacId": item.patVacId,
          "dueDate": item.dueDate,
          "patientId": this.patientObj.id ? this.patientObj.id : this.patientMoreData._id,
          "brand": ""
        }

        selectedVacArray.push(newObj);
      }
    });

    if (selectedVacArray.length) {

      console.log('Finally Array', selectedVacArray);

      this.patientService.uploadBulkVaccination(selectedVacArray).subscribe((response: any) => {
        console.log('RESPONSE VACCINE', response)
        if (response) {

          setTimeout(() => {
            // this.getPatientInfoForVac();
            this.getPatientsVaccination();
          }, 500);

          this.closeDialog();
        }
      })

    } else {
      alert("Please select vaccination records to be administered");

    }

  }
  setSelectedVaccinationRecord = (element: any) => {
    console.log("🔍 Function called: setSelectedVaccinationRecord");
    console.log("➡️ Passed element:", element);

    // Reset previous selection
    this.selectedVacIndex = null;
    this.selectedVacRecord = element;

    // 🧹 Remove this vaccine from selectedVaccination (to avoid re-saving as pending again)
    this.selectedVaccination = this.selectedVaccination.filter(
      (v: any) => String(v.patVacId ?? v.id) !== String(element.patVacId ?? element.id)
    );

    // ❌ Remove this vaccine from localStorage (pendingVaccinationForPrint)
    let pendingVaccines = JSON.parse(localStorage.getItem("pendingVaccinationForPrint") || "[]");
    const patientIndex = pendingVaccines.findIndex((p: any) => p.patientId === this.patientId);

    if (patientIndex !== -1) {
      const patientData = pendingVaccines[patientIndex];
      patientData.data = patientData.data.filter(
        (v: any) => !(v.name === element.name && v.visitName === element.visitName)
      );

      // If patient has no vaccines left, remove patient entry
      if (patientData.data.length === 0) {
        pendingVaccines.splice(patientIndex, 1);
      } else {
        pendingVaccines[patientIndex] = patientData;
      }

      localStorage.setItem("pendingVaccinationForPrint", JSON.stringify(pendingVaccines));
    }

    // 🧭 Set mode based on administered status
    this.viewOrRecordClicked = element.administeredStatus ? 'viewClicked' : 'recordClicked';

    // 🪟 Open preview modal
    setTimeout(() => {
      console.log("🪟 Opening vaccine preview modal");
      this.openDialog(this.previewVaccineModal, 'previewVaccineModal');
    }, 500);

    // 🧩 Find matching visit from full list
    const visitMatch = this.unformattedVaccineList.find((visit: any) => visit.name === element.visitName);

    if (visitMatch) {
      this.selectedVacVisit = visitMatch;

      // 🎯 Find the specific vaccine index inside the visit
      const dataMatchIndex = visitMatch.data?.findIndex(
        (v: any) => String(v.patVacId ?? v.id) === String(element.patVacId ?? element.id)
      );
      this.selectedVacIndex = dataMatchIndex ?? null;
      this.selectedVaccine = visitMatch.data?.[dataMatchIndex] || null;
      this.selectedDate = this.selectedVaccine?.administeredDate || null;

      // 🔍 Fetch brand info
      this.getBrandsByVaccineId();

      // 🏷️ Filter valid image labels
      const hasValidImage = (url: string) =>
        url && !url.endsWith('/vaccines/') && !url.endsWith('/vaccines/null');

      const vaccineLabels = visitMatch.data?.filter((v: any) => hasValidImage(v.imageUrl)) || [];
      this.selectedVaccineLabels = _.uniqBy(vaccineLabels, 'imageUrl');
    }
  };


  async handleVaccineSave() {
    console.log("handleVaccineSave viewOrRecordClicked", this.viewOrRecordClicked);

    try {
      const isRecording = this.viewOrRecordClicked === 'recordClicked';
      const hasPendingVaccines = this.selectedVaccination.length > 0;
      const hasPendingDate = !!this.pendingVaccinationDate;
      const shouldSavePending = hasPendingVaccines && hasPendingDate;

      // ✅ Step 1: Handle recording
      if (isRecording) {
        if (!this.selectedVaccine) {
          this.messageService.add({ severity: 'warn', detail: 'Please select a vaccine before saving.' });
          return;
        }

        if (this.selectedBrandIndex == null || !this.selectedBrand) {
          this.messageService.add({ severity: 'warn', detail: 'Please select a vaccine brand before saving.' });
          return;
        }

        if (!this.receivedDate) {
          this.messageService.add({ severity: 'warn', detail: 'Please select a received date before saving.' });
          return;
        }

        console.log("Calling markVaccineAsTaken()");
        await this.markVaccineAsTaken();
      }

      // ✅ Step 2: Handle clear-all-pending case early
      if (!hasPendingVaccines && !hasPendingDate) {
        const pendingVaccines = JSON.parse(localStorage.getItem("pendingVaccinationForPrint") || "[]");
        const index = pendingVaccines.findIndex((p: any) => p.patientId === this.patientId);

        if (index !== -1) {
          pendingVaccines.splice(index, 1);
          localStorage.setItem("pendingVaccinationForPrint", JSON.stringify(pendingVaccines));
        }

        this.closeDialog();
        this.refreshVaccinationList();
        return;
      }

      // ❌ Pending date only
      if (!hasPendingVaccines && hasPendingDate) {
        this.messageService.add({ severity: 'warn', detail: 'Please select a pending vaccine before saving.' });
        return;
      }

      // ❌ Pending vaccine only
      if (hasPendingVaccines && !hasPendingDate) {
        this.messageService.add({ severity: 'warn', detail: 'Please select a date for the pending vaccination before saving.' });
        return;
      }

      // ✅ Save pending vaccines
      if (shouldSavePending) {
        console.log("Calling savePendingVaccination()");
        await this.savePendingVaccination();
      }

      this.refreshVaccinationList();
    } catch (error) {
      console.error("Error in handleVaccineSave:", error);
      this.messageService.add({ severity: 'error', detail: 'Something went wrong. Please try again.' });
    }
  }



  async refreshVaccinationList() {
    console.log("Refreshing vaccination list...");

    // Fetch updated data from the server
    setTimeout(() => {
      this.getPatientsVaccination();
    }, 200);

    // Ensure change detection runs
    this.cdRef.detectChanges();
  }

  setSelectedSpecialVaccinationRecord = (element: any) => {
    setTimeout(() => {
      this.openDialog(this.specialVaccineModal, 'specialVaccineModal');
    }, 200);

    this.selectedVaccine = element;

    loopRecord: for (let index = 0; index < this.unformattedVaccineList.length; index++) {
      const visit = this.unformattedVaccineList[index];
      if (element.visitName == visit.name) {
        this.selectedVacVisit = visit;
        this.selectedVacIndex = element.index;
        this.selectedVaccIndex = element.index


        this.selectedDate = this.selectedVacVisit.data[this.selectedVacIndex].administeredDate;
        this.selectedVaccine = this.selectedVacVisit.data[this.selectedVacIndex]
        break loopRecord;
      }
    }
  }



  hideShowIAPGuidelines() {
    this.showInfo = !this.showInfo;
  }
  selectVaccine = (idx: any, vaccine: any) => {
    //aaleen
    var vaccBarnd: any = []
    this.vaccineBrands = []
    this.selectedVaccine = vaccine;
    this.selectedVaccIndex = vaccine.index
    if (vaccine.index) {
      this.selectedVacIndex = vaccine.index;
    }
    else {
      this.selectedVacIndex = idx;
    }

    this.selectedDate = this.selectedVacVisit?.data?.[idx]?.administeredDate ?? null;




    //logic for highlighting vaccines on the basis of BRANDS
    let brands: any = this.vaccineBrandsOrg;

    brands.map((item: any) => {
      var vaccines = item.mastervaccineids;
      var vaccinesArray = vaccines.split(',');
      let newArr = [];

      vaccinesArray.map((ins: any) => {
        if (ins != '') {
          newArr.push(Number(ins))
        }
      });

      item['highlighted'] = false;
      vaccinesArray.map((ins: any) => {
        if (ins != "" && ins == this.selectedVaccine.id) {
          item['highlighted'] = true
        }
      })

    });

    this.vaccineBrandsOrg = brands;
    this.vaccineBrandsOrg.map((ins: any) => {
      if (ins.highlighted) {
        vaccBarnd.push(ins)
      }
    })
    console.log(vaccBarnd)
    this.vaccineBrands = vaccBarnd
  }

  selectPendingVaccine = (idx: any, vaccine: any) => {
    //aaleen
    let pendingVaccines = this.pendingVaccines;
    if (!pendingVaccines[idx].selected) {
      pendingVaccines[idx].selected = true;
    } else {
      pendingVaccines[idx].selected = false;
    }
  }

  openVaccineInventory() {
    this.router.navigate([`/doctor/vaccineInventory`])
  }

  selectBrand = (idx: any, brand: any) => {
    this.selectedBrandIndex = idx;
    this.selectedBrand = brand;
    localStorage.setItem('selectedBrandData', JSON.stringify(brand));


    //logic for highlighting vaccines on the basis of BRANDS
    let pendingVaccines = this.selectedVacVisit.data;
    if (!brand.due) {
      var selectedVaccines = brand.mastervaccineids;
      var arr: any = selectedVaccines.split(',');
      let coversArray: any[] = []
      let covers = false;
      arr.map((ins: any) => {
        if (ins != "") {
          coversArray.push({ id: ins, covers: false })
        }
      })

      let selected = -1;

      loop1: for (let i = 0; i < pendingVaccines.length; i++) {
        loop2: for (let j = 0; j < coversArray.length; j++) {
          if (pendingVaccines[i].id == coversArray[j].id && selected != idx) {
            pendingVaccines[i]['covers'] = true;
            covers = true;
            continue loop1;
          } else {
            pendingVaccines[i]['covers'] = false;
          }
        }
      }

      this.selectedVacVisit.data = pendingVaccines;
      // this.setState({
      // selected = selected == idx ? -1 : idx;
      // let selectedComboVaccineId = brand.id;
    }
  }

  saveVaccineRecord = () => {
    const params = {
      patientId: this.patientObj.id ? this.patientObj.id : this.patientMoreData._id,
    };
  }

  saveSpecialVaccine = () => {
    this.saveSpecialVaccButton = true;

    let postData = this.patientMoreData;
    let parsed: any = null;

    if (postData.additionalInfo === "") {
      parsed = null;
    } else {
      parsed = JSON.parse(postData.additionalInfo);
    }

    const selectedVaccineName = this.specialSituationVaccines[this.selectedVacIndex].name;
    const vaccineName = selectedVaccineName === "Other" ? this.splVaccineName : selectedVaccineName;
    const formattedDate = moment(this.util.parseDate(this.receivedDate)).format('DD-MMM-YYYY');

    const specialVacObj = {
      name: vaccineName,
      administeredDate: formattedDate,
      administeredStatus: true
    };

    // 🔍 Check for duplicate
    if (parsed?.specialVaccination?.some((vac: any) =>
      vac.name === vaccineName && vac.administeredDate === formattedDate
    )) {
      this.saveSpecialVaccButton = false;
      this.toastr.error(`${vaccineName} vaccine is already recorded for this date.`);
      return; // ⛔ STOP — don't proceed further
    }

    // ✅ Proceed with save
    if (parsed) {
      if (parsed.specialVaccination && parsed.specialVaccination.length) {
        parsed.specialVaccination.push(specialVacObj);
      } else {
        parsed['specialVaccination'] = [specialVacObj];
      }
    } else {
      parsed = { specialVaccination: [specialVacObj] };
    }

    postData.additionalInfo = JSON.stringify(parsed);
    postData.visit = postData.visit ? postData.visit : [];
    this.patientMoreData['additionalInfo'] = JSON.stringify(parsed);

    const data = {
      HealthHistoryAdult: "HealthHistoryAdult",
      blood_group: this.patientMoreData.blood_group,
      additionalInfo: JSON.stringify(parsed)
    };

this.patientService.patientpartialupdate(data, this.patientMoreData._id).subscribe((response: any) => {
  if (response) {
    this.saveSpecialVaccButton = false;

    // update localStorage first (you already do this)
    localStorage.setItem("patientMoreData", JSON.stringify(this.patientMoreData));

    // refresh in-memory patient info
    this.getPatientInfoForVac();
    // re-fetch server list (if you rely on server), then merge specials
    this.getPatientsVaccination();

    // immediate local merge so UI shows the newly recorded special without full reload
    this.mergeSpecialVaccinesIntoList();
    this.ensureSpecialsAtTop();
    this.cdRef.detectChanges();

    this.closeDialog();
  }
});

  }


  parseDate(dateObject: any) {
    if (dateObject?.year) {
      return `${dateObject.year}-${dateObject.month}-${dateObject.day}`;
    } else {
      return `${dateObject}`
    }
  }
  formatDate(event: any) {
    const datePattern = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;

    // Check if the input matches the date pattern
    if (event.match(datePattern)) {
      this.patientDoB = event; // Save formatted date
      this.dateError = false;
    } else {
      this.dateError = true; // Set error if format is incorrect
    }
  }
  onDobChange() {
    // Delay the execution to wait for `patientDoB` to update
    setTimeout(() => {
      console.log("onDobChange fired");
      if (this.patientDoB) {
        // Calculate the minimum vaccination date (2 days after DOB)
        const minDate = new Date(this.patientDoB);
        minDate.setDate(minDate.getDate() + 2);
        this.minVaccinationDate = minDate;
        // Set `patientVaccinationDate` to exactly two days after `patientDoB`
        this.patientVaccinationDate = new Date(minDate);
        console.log("this.patientDoB:", this.patientDoB);
        console.log("this.patientVaccinationDate:", this.patientVaccinationDate);
        // Trigger change detection to update UI
        this.cdRef.detectChanges();
      } else {
        // Reset minVaccinationDate and patientVaccinationDate if DOB is cleared
        this.minVaccinationDate = null;
        this.patientVaccinationDate = null;
        this.cdRef.detectChanges();
      }
    }, 0); // This allows the DOM event to finish before running the rest of the code
  }

  formatVaccinationDate(event: any) {
    console.log(" laxus formatVaccinationDate fired");

    const parsedDate = moment(event, 'DD/MM/YYYY', true);
    if (parsedDate.isValid()) {
      this.patientVaccinationDate = parsedDate.toDate();

      // Log in DD/MM/YYYY to confirm format
      console.log("laxus Formatted patientVaccinationDate:", parsedDate.format('DD/MM/YYYY'));
    }
  }
  openDialog(content: any, index: any) {

    this.dialog.open(content);
  }
  resetVaccination() {
    this.confirmVaccDate = true;
    console.log("docUserIdAug27", this.patientMoreData.doctors[0].userId)
    var patInformationArray: any[] = []
    console.log("this.patientDoBthis.patientDoB", this.patientDoB);
    this.setDOBForMorePData = moment(this.parseDate(this.patientDoB)).format("DD-MMM-YYYY")
    console.log("this.this.patientVaccinationDate.", this.patientVaccinationDate);

    var postData = {
      dob: moment(this.parseDate(this.patientDoB)).format("YYYY-MM-DD"),
      vaccinationStartDate: moment(this.parseDate(this.patientVaccinationDate)).format("YYYY-MM-DD"),
      patientid: this.patientMoreData._id,
      docUserId: this.patientMoreData.doctors[0].userId
    }
    this.setVaccDateForMorePData = postData.vaccinationStartDate;
    console.log("patientresetVaccinationSchedule postdata", postData);

    this.patientService.patientresetVaccinationSchedule(postData)
      .subscribe((response: any) => {

        if (response) {

          this.dateError = false;

          console.log(response);

          this.closeDialog();

          this.getPatientInfoForVac();

          this.getPatientsVaccination();

          this.groupbyscheduleforasha();

          console.log("NOV66666", this.patientMoreData);

          let formatedDob =
            moment(this.parseDate(postData.dob))
              .format("DD/MM/YYYY");

          this.patientInfoArray = patInformationArray;

          this.patientMoreData = {
            ...this.patientMoreData,
            formattedVacStartDate: postData.vaccinationStartDate,
            formattedDOB: formatedDob,
            DOB: this.setDOBForMorePData
          };

          this.patientMoreData.vaccinationStartDate =
            this.setVaccDateForMorePData;

          console.log("AUGGG30", this.patientInfoArray);

          this.changedDOB =
            this.patientMoreData.formattedDOB;

          console.log('patientmoredata', this.patientMoreData);

          console.log("ChangedDOB", this.changedDOB);

          let birth = {
            key: 'Birth Date',
            value: moment(this.parseDate(postData.dob))
              .format("DD/MM/YYYY")
          };

          let vacStartDate = {
            key: 'Vac Start Date',
            value: moment(
              this.parseDate(postData.vaccinationStartDate)
            ).format("DD/MM/YYYY")
          };

          let joiningDate = {
            key: 'Joining Date',
            value: moment(this.patientMoreData.createdAt)
              .format('DD/MM/YY')
          };

          var y = moment(
            this.patientMoreData.formattedDOB,
            'DD/MM/YYYY'
          );

          var x = moment(this.patientMoreData.createdAt);

          let ageObj = moment.duration(x.diff(y));

          let ageAtJoining = {
            key: 'Age at Joining',
            value:
              `${Math.floor(ageObj.years())}y ` +
              `${Math.floor(ageObj.months())}m ` +
              `${Math.floor(ageObj.days())}d`
          };

          patInformationArray.push(
            birth,
            vacStartDate,
            joiningDate,
            ageAtJoining
          );

          // ✅ reload page
          setTimeout(() => {

            window.location.reload();

          }, 1000);

        }

      });
    setTimeout(() => {
      this.openDialog(this.infoPopUp, 0)
    }, 3500);

  }
  deletetakenvacc(element: any) {
    console.log("man15dec", element)
    this.deleteVaccineData = element
    const postData = {
      patVacId: element.patVacId,
      administeredDate: element.administeredDate,
      id: this.vaccineInventoriBrandId
    };

    // this.selectedVaccine=element
    // const storedBrand = localStorage.getItem('selectedBrand');
    //   this.selectedBrand = storedBrand ? JSON.parse(storedBrand) : null;
    // this.markVaccineAsTaken();
    console.log("dataelement", postData)
  }

  onClickVaccineDelete() {
    const brandId = this.refreshservice.getBrandId();
    this.vaccineInventoriBrandId = brandId
    const postData = {
      patVacId: this.deleteVaccineData.patVacId,
      administeredDate: this.deleteVaccineData.administeredDate,
      id: this.vaccineInventoriBrandId
    };
    this.docService.updatePatientVaccineTakenOn(postData).subscribe(response => {
      if (response) {

        window.location.reload();


        this.closeDialog();



      }

    })


  }
  isToday(date: any): boolean {
    if (!date) return false;

    const today = new Date();
    const administered = new Date(date);

    return (
      administered.getDate() === today.getDate() &&
      administered.getMonth() === today.getMonth() &&
      administered.getFullYear() === today.getFullYear()
    );
  }
private ensureSpecialHeaderAfterFilter(list: any[]): any[] {
  if (!Array.isArray(list)) return [];
  let firstSpecialFound = false;
  return list.map((v) => {
    if (v.visitName === 'Special Vaccines') {
      if (!firstSpecialFound) {
        firstSpecialFound = true;
        return { ...v, vaccineVisit: 'Special Vaccines' };
      } else {
        return { ...v, vaccineVisit: '' };
      }
    }
    return v;
  });
}



}

